module.exports = __webpack_public_path__ + "images/category_lp/retro_game/assessment_achievements/2@2x_f908a3b2c4b0aaa69b2e388bb248f615.png";